<template>
  <div>
    <h5>وظایف</h5>
    <b-card
        v-if="data"
        class="card-transaction"
        no-body
    >
      <b-card-body>
        <div
            v-for="task in data"
            :key="task.id"
            class="transaction-item"
        >
          <b-media no-body @click="goToTask()" class="cursor-pointer">
            <b-media-aside>
              <b-avatar
                  rounded
                  size="42"
                  :variant="task.priority.label"
              >
                <feather-icon
                    size="18"
                    :icon="task.priority.icon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body>
              <h6 class="transaction-title">
                {{ task.title }}
              </h6>
              <small>{{ task.creator.name }}</small>
            </b-media-body>
          </b-media>

        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody, BMediaBody, BMedia, BMediaAside, BAvatar, BDropdown, BDropdownItem,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BMediaBody,
    BMedia,
    BMediaAside,
    BAvatar,
    BDropdown,
    BDropdownItem,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  methods:{
    goToTask(){
      this.$router.push('/tasks/inbox')
    }
  }
}
</script>
